module.exports = __webpack_public_path__ + "static/christie-e663c7c78b7a124bb13a88c9cec40b4e.jpg";